import { Routes } from '@angular/router';
import { ReviewsComponent } from '@app/layouts/hospital/reviews/reviews';
import { DataTypesComponent } from '@app/layouts/hospital/data-types/data-types';
import { AnonymizedDataComponent } from '@app/layouts/hospital/anonymized-data/anonymized-data';

export const hospitalChildRoutes: Routes = [
  {
    path: 'reviews',
    component: ReviewsComponent,
  },
  { path: 'reviews/:id/data-types', component: DataTypesComponent },
  {
    path: 'reviews/:id/data-types/:data-type/anonymized-data',
    component: AnonymizedDataComponent,
  },
  { path: '**', redirectTo: 'reviews' },
];
